import {Component} from "react";
import Glob from "../../../libs/Glob.mjs";
import "./SimulationFlowRunning.css";
import {Button, ButtonGroup, Progress} from "reactstrap";
import ChevronLeftIcon from "../../../media/images/ChevronLeftIcon.mjs";
import TextLabel from "../../../controls/TextLabel/TextLabel.mjs";
import appLib from "../../../libs/appLib.mjs";
import ChevronRightIcon from "../../../media/images/ChevronRightIcon.mjs";
import RefreshIcon from "../../../media/images/RefreshIcon.mjs";

const prefix = "SimulationFlowRunning";

const SimulationFlowRunning = class extends Component {
	constructor(props) {
		super(props);
		this.state = {
			update: Date.now(),
			simul: props.simul,
			ll: Glob.getLanguageLong()
		};
		this.uid = Glob.generateUid(prefix);
		this.refresh = this.refresh.bind(this);
		this.renderStatus = this.renderStatus.bind(this);
	}
	componentDidMount() {
		setTimeout( this.refresh );
	}
	refresh( rs ) {
		if ( ! rs ) {
			appLib.api('simul/running-status', {id:this.state.simul.id}).then( this.refresh );
			return;
		}
		const ns = {
			update: Date.now(),
			running: rs
		};
		this.setState(ns, ()=>{
			if ( rs.started && ! rs.completed ) {
				setTimeout( this.refresh, 3000 );
			} else if ( rs.status !== this.props.simul.status ) {
				appLib.api("simul/get", { id: this.state.simul.id }).then( this.props.afterSave );
			}
		});
	}
	renderStatus( r = {} ) {
		if ( r.completed ) return <h5><TextLabel value={"Simulation completed"} /></h5>;
		if ( r.started ) return <h5><TextLabel value={"Simulation started"} /></h5>;
		return null;
	}
	render() {
		return (
			<>
				<div className={"panel-content limited " + prefix}>
					<h3>
						<TextLabel value={"Running"} />
					</h3>
					{ this.state.running ? (
						<div>
							<div  className={"glance"}>
								{ (this.state.running?.started && ! this.state.running?.completed) && (
									<div className={"running-icon"}>
										<RefreshIcon />
									</div>
								)}
								{ this.renderStatus( this.state.running ) }
								{ this.state.running.elapsed && (
									<div>
										<TextLabel value={"Time elapsed"} />: { (this.state.running.elapsed/1000).toFixed( 2 ) } s
									</div>
								)}
							</div>
							{ (this.state.running.steps && this.state.running.steps.length > 0) && (
								<div>
									<h5>
										<TextLabel value={"Simulation steps"} />
									</h5>
									<table className="table table-striped">
										<thead>
											<tr>
												<th>
													<TextLabel value={"Stage"} />
												</th>
												<th>
													<TextLabel value={"Start time"} />
												</th>
												<th style={{ textAlign: "right" }}>
													<TextLabel value={"Time elapsed"} />
												</th>
												<th style={{ textAlign: "right" }}>
													<TextLabel value={"Changes"} />
												</th>
											</tr>
										</thead>
										<tbody>
										{ this.state.running.steps.map((s, i) => (
											<tr key={i}>
												<td>
													{ s.stage }
												</td>
												<td>
													{ (new Date( s.startTime)).toLocaleString( this.state.ll ) }
												</td>
												<td style={{ textAlign: "right" }}>
													{ ( s.elapsed/1000 ).toFixed(2) } s
												</td>
												<td style={{ textAlign: "right" }}>
													{ s.changes }
												</td>
											</tr>
										))}
										</tbody>
									</table>
								</div>
							)}
						</div>
					) : (
						<div className={"p-3"}>
							<Progress animated={true} value={100} striped />
						</div>
					)}
				</div>
				<div className={"panel-footer"}>
					<ButtonGroup className={"btn-icon"}>
						<Button
							color={"success"}
							onClick={() => {
								Glob.setCurrentPageParam('step', 'ready')
							}}
						>
							<i>
								<ChevronLeftIcon/>
							</i>
							<b>
								<TextLabel value={"Simulation start"}/>
							</b>
						</Button>
					</ButtonGroup>
					<ButtonGroup className={"btn-icon"}>
						<Button
							color={"success"}
							disabled={ ! this.state.running?.completed }
							onClick={() => { Glob.setCurrentPageParam('step', 'over') }}
						>
							<b>
								<TextLabel value={"Simulation completed"} />
							</b>
							<i>
								<ChevronRightIcon/>
							</i>
						</Button>
					</ButtonGroup>
				</div>
			</>
		);
	}
}

export default SimulationFlowRunning;